import { Observable, Subject } from 'rxjs';
import { SpecialtyModel } from '../../models';

export abstract class BaseSpecialtyService {
  public abstract specialtyUpdate: Subject<string>;
  public abstract getSpecialty(pathNid: string): Observable<SpecialtyModel>;
  public abstract getAllSpecialties(): Observable<SpecialtyModel[]>;
  public abstract getFeaturedSpecialties(): Observable<SpecialtyModel[]>;
  public abstract getSelectedArray(): number[];
  public abstract getSelectedSpecialties(): Observable<any>;
  public abstract setSelected(nid): void;
  public abstract removeSelected(nid): void;
  public abstract navigateSelected(nid): void;
  public abstract clearSelected(): void;
  public abstract convertNidToSpecialty(array: string[]): SpecialtyModel[];
  public abstract setSelectedSpecs(array: SpecialtyModel[]);
  public abstract getSelectedSpecs();
}
